export default (text, textMaxLength, includeDots) => textMaxLength && text && text.length > textMaxLength
    ? `${text.substr(0, textMaxLength - (includeDots && textMaxLength > 3 ? 3 : 0))}...`
    : text;
